/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import { get } from 'lodash';
import { searchUsers, fetchUserProfile, getUserId } from '@/api';
import { USER_LIST, USER_SET_ID, USER_SET_PROFILE } from '@/store/mutation-types';


const state = {
  users: [],
  profile: {},
  loadingProfile: false,
  userId: null,
};


const getters = {
  list(state) {
    return state.users;
  },
  loadingProfile(state) {
    return state.loadingProfile;
  },
  userAccess(state) {
    return parseInt(get(state, 'profile.user_access', 10), 10);
  },
};


const actions = {
  fetchUserProfile: async function _fetchUserProfile({ commit, state }) {
    const userToken = this.getters['auth/userToken'];

    commit('LOADING_PROFILE', true);

    if (!state.userId) {
      const { data: user } = await getUserId(userToken);
      commit(USER_SET_ID, get(user, '[1].data.details.user_id'));
    }

    const { data: profile } = await fetchUserProfile(userToken, state.userId);
    commit(USER_SET_PROFILE, get(profile, '[1].data.details.user_data', {}));
    commit('LOADING_PROFILE', false);
  },
  searchUsers({ commit }, val) {
    const userToken = this.getters['auth/userToken'];
    searchUsers(userToken, val)
      .then(({ data }) => {
        const users = get(data, '[1].data.details', []);
        commit(USER_LIST, users);
      })
      .catch(() => {
      });
  },
};


const mutations = {
  LOADING_PROFILE(state, value) {
    state.loadingProfile = value;
  },
  [USER_LIST](state, users) {
    state.users = users;
  },
  [USER_SET_PROFILE](state, profile) {
    state.profile = profile;
  },
  [USER_SET_ID](state, id) {
    state.userId = id;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js